import * as React from 'react';
import { RenderElementProps } from 'slate-react';
import styled from 'styled-components';

import { colorsV2 } from '../../../../colors-v2';
import { ColorDefinition } from '../types';

interface HighlightElementProps extends RenderElementProps {
  color: ColorDefinition;
}

const HighlightWrapper = styled.span``;

export const HighlightElement = ({ children, color: { key, color } }: HighlightElementProps) => {
  return (
    <HighlightWrapper
      className="highlight-element-wrapper"
      style={{ backgroundColor: color || colorsV2.white100, borderRadius: 4, padding: '2px 3px' }}
      color={color}
      data-highlight-color-key={key}
    >
      {children}
    </HighlightWrapper>
  );
};
